import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function LatestUpdates() {
  const latestVideos = [...videos]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 6);

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              每日更新精选打屁股视频，不错过任何精彩内容
            </p>
          </div>
          <Link
            to="/category/parent-child-education"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap"
          >
            全部视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-colors hover:bg-background-200/70"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={video.thumbnailUrl}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
                  {video.duration}
                </div>
                {video.date >= '2026-08-04' && (
                  <div className="absolute top-2 left-2">
                    <span className="bg-accent-500 text-foreground-950 text-xs px-2 py-0.5 rounded-full font-medium">
                      新
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
                    {video.categoryName}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <p className="text-foreground-500 text-xs line-clamp-2 leading-relaxed mb-3">
                  {video.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views >= 10000
                      ? `${(video.views / 10000).toFixed(1)}万`
                      : video.views}
                  </span>
                  <span>{video.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/parent-child-education"
            className="flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors"
          >
            全部视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}